//GeneratorFlag:[NoChange]
import PersonRole from './person-role';

export default {PersonRole}
export{PersonRole}